<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout_title">
        <h3>Reporte de productos/servicios más vendidos</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button @click="consultar" type="button" class="btn-info btn--bigger">
            <i class="fa fa-search"></i>
            <span>Consultar</span>
          </button>
          <button @click="exportar" type="button" class="btn-success btn--bigger">
            <i class="fa fa-file-excel-o"></i>
            <span>Exportar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div class="form-field select">
              <div class="select-field select-field--stretch">
                <select name="tipo_item" id="tipo_item" v-model="form.tipo_item">
                  <option value="T">Todos</option>
                  <option value="P">Productos</option>
                  <option value="S">Servicios</option>
                </select>
                <label for="tipo_item">Tipo</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2 select2-field--stretch">
              <div class="select2-field">
                <v-select
                  placeholder="Seleccione..."
                  id="categoria"
                  @input="inputCategoria"
                  v-model="selectedCategoria"
                  :options="categorias"
                  label="nombre"
                ></v-select>
                <label for="categoria">Categoría</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2 select2-field--stretch">
              <div class="select2-field">
                <v-select
                  placeholder="Seleccione..."
                  id="marca"
                  @input="inputMarca"
                  v-model="selectedMarca"
                  :options="marcas"
                  label="nombre"
                ></v-select>
                <label for="marca">Marca</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="form-inline">
              <label>
                <p>
                  <strong>Fecha:</strong>
                </p>
              </label>
              <label for="hoy">
                <input v-model="form.tipoFecha" type="radio" name="tipoFecha" id="hoy" value="H" />
                <span>Hoy</span>
              </label>
              <label for="ayer">
                <input v-model="form.tipoFecha" type="radio" name="tipoFecha" id="ayer" value="A" />
                <span>Ayer</span>
              </label>
              <label for="a_fecha">
                <input v-model="form.tipoFecha" type="radio" name="tipoFecha" id="a_fecha" value="F" />
                <span>A la fecha</span>
              </label>
              <label for="rango">
                <input
                  @change="changeFechas"
                  v-model="form.tipoFecha"
                  type="radio"
                  name="tipoFecha"
                  id="rango"
                  value="R"
                />
                <span>Filtrar por fechas</span>
              </label>
              <div class="form-field" v-show="form.tipoFecha === 'R'">
                <div class="datepicker-field datepicker-field--stretch">
                  <date-picker
                    name="fechaDesde"
                    v-model="form.fechaDesde"
                    type="date"
                    format="dd-MM-yyyy"
                    id="desde"
                    lang="es"
                  ></date-picker>
                  <label>Desde</label>
                </div>
              </div>
              <div class="form-field" v-show="form.tipoFecha === 'R'">
                <div
                  class="datepicker-field datepicker-field--stretch"
                  v-show="form.tipoFecha === 'R'"
                >
                  <date-picker
                    name="fechaHasta"
                    v-model="form.fechaHasta"
                    type="date"
                    format="dd-MM-yyyy"
                    id="hasta"
                    lang="es"
                  ></date-picker>
                  <label>Hasta</label>
                </div>
              </div>
            </div>
          </div>          
        </div>
      </div>
    </div>
    <div class="card" v-show="registros.length > 0">
      <div class="card__content">
        <tablaMasVendidos :registros="registros"></tablaMasVendidos>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    marcas: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    categorias: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    }
  },
  data: function() {
    return {
      form: {
        consultar: 'C',
        marca_id: "",
        categoria_id: "",
        tipo_item: "T",
        tipoFecha: "H",
        fechaDesde: "",
        fechaHasta: ""
      },
      selectedCategoria: null,
      selectedMarca: null,
      registros: []
    }
  },
  methods: {
    inputMarca: function() {
      if (this.selectedMarca !== null)
        this.form.marca_id = this.selectedMarca.id;
      else this.form.marca_id = "";
    },
    inputCategoria: function() {
      if (this.selectedCategoria !== null)
        this.form.categoria_id = this.selectedCategoria.id;
      else this.form.categoria_id = "";
    },
    consultar: function() {
      this.form.consultar = 'C';
      let that = this;
      let urlApi = url + '/comprobantes/reporte-mas-vendidos';
      axios.post(urlApi, that.form).then(function(response) {
        that.registros = JSON.parse(JSON.stringify(response.data));
      }).catch(function (error) {
        let response = error.response;
        if (response !== null && response !== undefined) {
          if (response.status === 422)
            swal('Debe ingresar las fechas', 'Aviso', 'warning');
          else 
            swal('Hubo un error, intente nuevamente.', 'Aviso', 'warning');
        }
      });
    },
    exportar: function() {
      this.form.consultar = 'E';
      let urlApi = url + '/comprobantes/reporte-mas-vendidos' + this.serialize(this.form);
      window.open(urlApi, '_blank');
    },
    changeFechas: function() {
      let desde = new Date();
      desde.setDate(desde.getDate() - 7);
      this.form.fechaDesde = moment(desde).format("YYYY-MM-DD");
      this.form.fechaHasta = moment(new Date()).format("YYYY-MM-DD");
    },
    serialize: function(obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function(a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/reportes/ReporteMasVendidos.vue